import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import Utils from 'medscape/utils';
import InfositeHelpers from 'infosite/helpers';
import ToggleButton from './toggle-button';
import IsiStore from './store';
import IsiActions from './actions';
import Tracking from 'medscape/tracking';
import { get } from 'lodash';
import './styles.scss';
let ContentCache = {};
const $window = $(window);
export default class ISI extends Reflux.Component {
  constructor(props) {
    super(props);
    //const pagePosition = props.config["page-position"];
    //const displayType = window.medscape.isMobile ? pagePosition.mobile : pagePosition.desktop;
    this.state = {
      moduleHeight: '',
      content: ''
    }
    if(!this.props.config.isExpanded){
      this.props.config.collapseEvent.time=0;
      this.props.config.collapseEvent.acceptButton=false;
    }
    this.store = new IsiStore(props);
    this.collapseTime = null;
    this.scrollInterval = null;
    this.isNewArticle = true;
  }
  componentWillUnmount(){
      if(this.props.isSticky){
        $(window).off('scroll.isi');
        $(window).off('resize.isi orientationchange.isi');
        $(document).off("article:load.isi");
      }
      this.store.stopListeningToAll();
  }
  componentWillMount() {
    Reflux.Component.prototype.componentWillMount.call(this);
    //this.getContent(this.props.config.path);
    IsiActions.getContent(this.props.config.path)
  }
  componentDidMount(){
    let $this = $(ReactDOM.findDOMNode(this));
    if(this.props.isSticky){
      $window.off('scroll.isi').on('scroll.isi',(e)=>{
        this.checkStickyDisplay();
      })
      $(window).off('resize.isi orientationchange.isi').on('resize.isi orientationchange.isi',(e)=>{
        this.checkStickyDisplay();
        this.setModuleHeight();
      })
      $(document).on("article:load.isi",(e,page)=>{
        this.isNewArticle = true;
        if(this.props.config.isAutoScroll){
          IsiActions.toggleAutoScroll(true);
        }
      })
    }

    this.doRender();

  }
  componentWillUpdate(nextProps, nextState) {
    //this.getContent(nextProps.config.path);
    clearInterval(this.scrollInterval);
  }
  componentDidUpdate(prevProps, prevState){
    let $this = $(ReactDOM.findDOMNode(this));

    if(this.state.scrollTo && !this.props.isSticky){
        this.state.scrollTo = this.store.state.scrollTo = false;
        let isiModule = $('.isi-module')[0];
        isiModule.scrollIntoView();
        window.scrollBy(0,  -$('header').height()-20);
    }
    this.doRender();
  }
  checkStickyDisplay() {
      let $this = $(ReactDOM.findDOMNode(this));
      const docViewTop = $window.scrollTop();
      const docViewBottom = docViewTop + $(window).height();
      const elemTopScrollPadding = get(this, 'props.config.pageSettings.desktop.scrollPadding', 20);
      let $isiEl = $('#isi-article-container');
      if($isiEl.length==0){
        return;
      }
      let offset = $isiEl.find('.header-container').height()+elemTopScrollPadding;
      const elemTop = $isiEl.offset().top + offset;
      const elemBottom = elemTop + $isiEl.height();
      const isIsiVisible = elemTop<docViewBottom;
      if (isIsiVisible == this.state.isVisible) {
        IsiActions.toggleSticky();
      }
  }
  initAutoScroll(){
    let $this = $(ReactDOM.findDOMNode(this));
    let $scrollEl = $this.find('.content-scroll-area');
    if(!this.state.isAutoScroll || this.props.isInline || $scrollEl.length==0){
      return;
    }
    if(this.isNewArticle){
      this.isNewArticle = false;
      $scrollEl[0].scrollTop = 0;
    }
    const speed = this.props.config.scrollTimer;

    this.scrollInterval = setInterval(()=>{
      $scrollEl[0].scrollTop += 1;
    }, speed || 100);
    $scrollEl.one('DOMMouseScroll mousewheel',()=>{
      IsiActions.toggleAutoScroll(false);
    });
    $scrollEl.one('click.isiScroll',()=>{
      IsiActions.toggleAutoScroll(false);
    });

  }
  doRender(){
      let $this = $(ReactDOM.findDOMNode(this));
      if(this.props.isSticky && this.state.isExpanded){
          let collapseEvent = this.props.config.collapseEvent;
          if(!this.state.isTimerFinished && collapseEvent.time && collapseEvent.time>0){
            this.collapseTime = setTimeout( ()=>{
              IsiActions.toggle(false);
            },this.props.config.collapseEvent.time*1000)
          }
          InfositeHelpers.lockScroll("isi-module");
      }
      else if(this.props.isSticky && !this.state.isExpanded){
        InfositeHelpers.unlockScroll("isi-module");
        this.checkStickyDisplay();
      }
      this.initAutoScroll();
      Tracking.trackContainerLinks($this[0]);
      this.setModuleHeight()
  }
  setModuleHeight() {
    //let $this = $(ReactDOM.findDOMNode(this));
    let moduleHeight = "";
    let screenHeight = $(window).outerHeight();
    let $headerEl = $('header');
    if (this.props.isInline) {
      moduleHeight = "";
    }
    else if(!this.state.isExpanded){
      const collapseHeight = window.medscape.isMobile ? this.props.config.pageSettings.mobile.height : this.props.config.pageSettings.desktop.height;
      moduleHeight = collapseHeight;
    }
    else if(this.props.isSticky){

      //let screenHeight = $(window).outerHeight();
      //let $headerEl = $('header');
      const isHeaderVisible = Utils.isElementInViewport($headerEl[0]);
      let offsetTop = $headerEl.offset()['top'] - (window.pageYOffset + window.innerHeight);
      let visibleHeight = $headerEl.height();
      if(isHeaderVisible){
        visibleHeight = $headerEl.height() + $headerEl.offset()['top'];
      }
      let headerHeight = isHeaderVisible ? visibleHeight : 0;
      //moduleHeight = screenHeight - headerHeight;
      moduleHeight = screenHeight;
      if(this.state.isExpanded && !this.state.isAccepted && this.props.config.collapseEvent.acceptButton){
        moduleHeight = screenHeight;
      }
    }
    if(moduleHeight != this.state.moduleHeight){
      this.setState({
        moduleHeight: moduleHeight
      })
    }
  }
  render() {
    if ( !this.state.isVisible || !this.state.content || this.state.content.length == 0) {
      return false;
    }

    let moduleProps = {
      className: cx({
        "isi-module": true,
        "expanded": this.state.isExpanded,
        "inPage": !this.props.isSticky,
        "hidden": !this.state.isVisible && !this.props.isInline
      }),
      style: {
        "height": this.state.moduleHeight
      }
    }

    let content = Utils.getDangerousHtml(this.state.content);
    const renderToggleButton = !this.props.isInline;
    const acceptButton = this.props.config.collapseEvent.acceptButton;

    let toggleProps = {
      render: renderToggleButton,
      showAcceptButton: (this.props.isSticky && acceptButton ? acceptButton && !this.state.isAccepted : false),
      isExpanded: this.state.isExpanded,
      onClick: (e) => {
        e.preventDefault();
        clearTimeout(this.collapseTime);
        if(this.props.isSticky && acceptButton && !this.state.isAccepted){
          IsiActions.accept();
        }
        else{
          IsiActions.toggle();
        }
      }

    }

    return (
      <div {...moduleProps}>
        <div className="header-container">
          <div className="container">
            <h3>{this.props.config.header}</h3>
            <ToggleButton {...toggleProps} />
          </div>
        </div>
        <div className="content-container">
            <div className="content-scroll-area">
              <div className="container content" dangerouslySetInnerHTML={content}></div>
          </div>
        </div>
      </div>
    );
  }
}

ISI.propTypes = {
  config: React.PropTypes.object,
  isInline: React.PropTypes.bool,
  isExpanded: React.PropTypes.bool,
  isSticky: React.PropTypes.bool
}
ISI.defaultProps = {
  isExpanded: false,
  isInline: true,
  isSticky: false
}



// WEBPACK FOOTER //
// ./src/app/isi/app.jsx